import * as Yup from 'yup';

import { FormPage } from 'components/page';
import { BandaPrecoGeneralBlock } from 'pages/complementar/banda-preco/components/templates/BandaPrecoGeneralBlock';
import { useLoaderContext } from 'context/LoaderContext';
import { usePostBandaPreco } from 'pages/complementar/banda-preco/hooks';
import { BandaPreco } from 'pages/complementar/banda-preco/types';

export function BandaPrecoFormComp() {
    const { handleSubmit, isLoading } = usePostBandaPreco();

    useLoaderContext(isLoading);

    const validationSchema = Yup.object({
        dreMercadologicaGrupoExibicao: Yup.object().required(),
        peBandaPreco: Yup.number().required(),
        dtInicioVigencia: Yup.string().required(),
    });

    const mapContentToInitialValues = (data: BandaPreco): BandaPreco => {
        if (data.dtInicioVigencia && !data.dtInicioVigencia?.endsWith('T00:00:00')) {
            data.dtInicioVigencia = `${data.dtInicioVigencia}T00:00:00`;
        }

        return data;
    };

    return (
        <FormPage
            fgAtivo
            goBackButton
            title="Banda de Preço"
            url="/dre/dremercadologicagrupoexibicaobandapreco/"
            values={{}}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            mapContentToInitialValues={mapContentToInitialValues}
        >
            <BandaPrecoGeneralBlock />
        </FormPage>
    );
}
